export default {
	docVersion: "v1",
	API_BASE: "https://us-central1-candoo-tech.cloudfunctions.net",
	ACCESS_TOKEN: "8498fc3f-337d-4f3f-8a4c-02809fa9939c",
}
